import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getBlogListApi = createAsyncThunk("client/blogs-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/blogs/api/v1/blogs-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("get blog-list response", response);
    return response;
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data || "Failed to fetch blog-list");
  }
});

//  get blog with Rowid

export const getBlogWithRowidApi = createAsyncThunk("/blogs-details", async (rowid, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}admin/blogs/api/v1/blogs-details/${rowid}`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("get blog-detail response", response);
    return response;
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data || "Failed to fetch blog-detail");
  }
});

// get count of blogs

export const getBlogCountApi = createAsyncThunk("/blog-count", async (_, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.get(
      `${baseUrl}admin/blogs/api/v1/blog-count`,

      {
        headers: {
          "auth-token": token,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("get blog-count response", response);
    return response;
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data || "Failed to fetch blog-count");
  }
});
